<template>
    <div class="product-content">
        <p class="tit">字段列表 <span>（可拖动排序）</span></p>
        <template>
            <h3 style="margin-left:10px ;"> {{ list.title }}</h3>
            <vuedraggable @end="handleDragEnd" v-model="list.data" tag="ul" draggable="li" class="list">
                <li class="item" v-for="(item, index) in list.data" :key="index">
                    <div>
                        <el-input v-model="item.name" placeholder="请输入内容"> <template slot="append"> {{ item.key
                        }}</template></el-input>
                    </div>

                    <i class="el-icon-error" @click="orshow(index)"></i>
                </li>
            </vuedraggable>
        </template>
        <div style="width: 100%;text-align: center;">
            <el-button type="primary" @click="resetit()">重新加载字段</el-button>
        </div>
    </div>
</template>

<script>
import vuedraggable from 'vuedraggable'
export default {
    name: 'Product',
    components: {
        vuedraggable
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            list: {},
            loading: false,
            show: false,
            loadingOption: false
        }
    },
    watch: {
        'list.data'(newValue, oldValue) {
            this.$forceUpdate()
            console.log('Property changed from', oldValue, 'to', newValue);
        }
    },
    mounted() {
        this.list = this.data;
        // this.resetit()
        this.$forceUpdate()
        console.log(this.list)
        this.loadingOption = true
    },
    methods: {

        handleDragEnd(e) {
            console.log(this.list.data, e, '结束拖拽')
            this.$forceUpdate()
        },
        orshow(index) {
            this.list.data.splice(index, 1);
        },
        resetit() {
            this.list.title = '产品信息'
            this.list.data = [
                { name: '产品图片:', ifshow: true, key: 'productPic' },
                { name: '产品名称:', ifshow: true, key: 'product_name' },
                { name: '产品编码:', ifshow: true, key: 'product_code' },
                { name: '生产时间:', ifshow: true, key: 'productTime' },
                { name: '有效期:', ifshow: true, key: 'periodDate' },
                { name: '批次号:', ifshow: true, key: 'batchNo' },
                { name: '首次扫码时间:', ifshow: true, key: 'create_time' },
                { name: '扫码次数:', ifshow: true, key: 'count' },
                { name: '追溯码:', ifshow: true, key: 'qrcode' },
                { name: '追溯箱码:', ifshow: true, key: 'qrcodeParent' },
                { name: '规格:', ifshow: true, key: 'specs' },
                { name: '出库时间:', ifshow: true, key: 'outBillTime' },
                { name: '生产工厂:', ifshow: true, key: 'enterpriseName' },
                { name: '经销商:', ifshow: true, key: 'dealerName' },
            ]
        },
    }
}
</script>

<style lang="scss">
.product-content {
    .tit {
        text-align: center;
        font-size: 12px;
        color: #666;
        margin: 18px 0;
        padding-bottom: 10px;
        border-bottom: 1px dashed #ddd;
    }

    .add-btn {
        width: calc(100% - 30px);
        height: 34px;
        line-height: 34px;
        padding: 0;
        font-size: 12px;
        margin-left: 15px;
        margin-top: 5px;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        padding: 12px;
        margin: 0;

        .item {
            width: 100%;
            // height: 70px;
            // padding: 10px;
            border-radius: 6px;
            margin: 4px;
            position: relative;
            transition: all .3s;
            list-style: none;

            img {
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }

            i {
                position: absolute;
                top: -6px;
                right: -6px;
                cursor: pointer;
                opacity: 0;
                transition: all .3s;
                color: red;
            }

            &::before {
                content: '';
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0;
                right: 0;
                background: rgba(0, 0, 0, .4);
                border-radius: 4px;
                opacity: 0;
                transition: all .3s;
            }

            &:hover {
                cursor: grab;

                &::before,
                i {
                    opacity: 1;
                }
            }
        }
    }

    .options {
        padding: 15px;
        border-radius: 6px;

        .el-form {
            background: #f7f8f9;
            overflow: hidden;
            padding: 10px 0;

            .el-form-item {
                margin: 0;

                label {
                    font-size: 12px;
                }
            }
        }
    }
}
</style>